export const NotFound = () => {
  return <p>No encontrado (404)</p>;
};
